export const MOBILE_WIDTH = 768;
